module.exports = __webpack_public_path__ + "json/data.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/json/data.json
 ** module id = 885
 ** module chunks = 0
 **/